import "animate.css";
import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";

import {
  academicYears,
  getBranchContractPayload,
  getPagePayload,
  resolveAcademicYear,
} from "years";

import CardInfo from "components/CardInfo";
import DetailContact from "components/DetailContact";
import LoadingSpin from "components/Loading";
import ScrollUpBtn from "components/ScrollUpBtn";

import { CardContainer, Container, Title } from "./serviceSUT.style";

const ServiceSUT = ({ year }) => {
  const [serviceData, setServiceData] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const currentAcademicYear =
    academicYears.find(({ ce }) => ce === resolveAcademicYear(year)) ||
    academicYears[0];

  useEffect(() => {
    window.scrollTo(0, 0);

    getDataService();
    getDataContact();
  }, [year]);

  const getDataService = () => {
    setIsLoading(false);
    const response = { data: getPagePayload(year, "service") };

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setIsLoading(true);
      setServiceData(data);
    } else {
      setIsLoading(true);
      setServiceData([]);
    }
  };
  const getDataContact = () => {
    const response = { data: getBranchContractPayload(year, "996") };

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setContactData(data);
    } else {
      setContactData([]);
    }
  };

  return (
    <>
      <Container>
        <Row>
          <Col span={24}>
            <Title className="animate__animated animate__flipInX animate__slow">
              การให้บริการมหาวิทยาลัย {currentAcademicYear.be}
            </Title>
          </Col>
        </Row>
        {isLoading ? (
          <>
            <CardContainer>
              {serviceData.length >= 0 &&
                serviceData.map((item, index) => {
                  const textEN = item?.nameEN.split(" ");

                  return (
                    <CardInfo
                      key={index}
                      src={item?.image}
                      name={item?.nameTH}
                      titleImage={textEN[0]}
                      nameImage={textEN[1]}
                      cursor="false"
                      link={item?.link}
                    />
                  );
                })}
            </CardContainer>

            {contactData && (
              <Row gutter={24} className="row-contact">
                {contactData.length > 1 &&
                  contactData.map((item, index) => {
                    return (
                      <Col span={8} style={{ padding: "10px" }} key={index}>
                        <div style={{ marginBottom: "5px" }}>
                          <DetailContact
                            color="var(--black)"
                            title={item?.title}
                            phone={item?.phone_1}
                            office={item?.phone_2}
                            facebook={item?.fb}
                            website={item?.site}
                            email1={item?.email_1}
                            email2={item?.email_2}
                            line={item?.line}
                            address={item?.address}
                            indentAddress={"40"}
                            indent={"40"}
                            type="branch"
                            titleWebsite="เว็บไซต์"
                          />
                        </div>
                      </Col>
                    );
                  })}
              </Row>
            )}
          </>
        ) : (
          <LoadingSpin />
        )}
      </Container>

      <ScrollUpBtn />
    </>
  );
};

export default ServiceSUT;
